import { render, staticRenderFns } from "./BtnInserirCronogramaDesembolsoParceiro.vue?vue&type=template&id=6dcc8b57"
import script from "./BtnInserirCronogramaDesembolsoParceiro.vue?vue&type=script&lang=js"
export * from "./BtnInserirCronogramaDesembolsoParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports